import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { getMyProfile, updateMyProfile } from '../services/users.service';
import BottomNav from '../components/BottomNav';
import PublicProfile from './PublicProfile';
import { FaCamera, FaUser, FaChevronRight } from 'react-icons/fa';
import AdminPanel from './AdminPanel';
import LegalPanel from '../components/LegalPanel';
import { PRIVACIDAD, TERMINOS } from '../data/legalContent';

const API = 'https://sendvigo-backend-production.up.railway.app';

const MenuItem = ({ emoji, label, sublabel, onClick, danger }) => (
  <button onClick={onClick}
    style={{backgroundColor: 'transparent', borderBottom: '1px solid #1e2028'}}
    className="w-full flex items-center justify-between px-4 py-4 hover:bg-gray-800 transition duration-200">
    <div className="flex items-center gap-3">
      <span style={{fontSize: '18px'}}>{emoji}</span>
      <div className="text-left">
        <p style={{fontSize: '14px', fontWeight: '500', color: danger ? '#f87171' : 'white'}}>{label}</p>
        {sublabel && <p style={{color: '#6b7280', fontSize: '12px', marginTop: '1px'}}>{sublabel}</p>}
      </div>
    </div>
    <FaChevronRight style={{color: '#3a3d45', fontSize: '11px'}} />
  </button>
);

const Panel = ({ children }) => (
  <div className="mx-4 my-2 rounded-2xl p-5" style={{backgroundColor: '#1a1d24', border: '1px solid #2a2d35'}}>
    {children}
  </div>
);

const InputField = ({ placeholder, value, onChange, type = 'text' }) => (
  <input type={type} placeholder={placeholder} value={value} onChange={onChange}
    style={{backgroundColor: '#111318', border: '1px solid #2a2d35', color: 'white',
      borderRadius: '12px', padding: '11px 14px', fontSize: '14px', width: '100%'}}
    className="focus:outline-none focus:ring-1 focus:ring-orange-500 placeholder-gray-600" />
);

export default function MyProfile({ onBack, onTabChange }) {
  const { token, user: authUser, login, logout } = useAuth();
  const [profile, setProfile] = useState(null);
  const [name, setName] = useState('');
  const [bio, setBio] = useState('');
  const [message, setMessage] = useState('');
  const [editingPersonal, setEditingPersonal] = useState(false);
  const [editingPassword, setEditingPassword] = useState(false);
  const [showLang, setShowLang] = useState(false);
  const [showAyuda, setShowAyuda] = useState(false);
  const [showSobre, setShowSobre] = useState(false);
  const [showPrivacidad, setShowPrivacidad] = useState(false);
const [showTerminos, setShowTerminos] = useState(false);
  const [showPerfil, setShowPerfil] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPassword2, setNewPassword2] = useState('');
  const fileInputRef = useRef();
  const [showAdmin, setShowAdmin] = useState(false);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    if (!token) return;
    getMyProfile(token).then(data => {
      if (!data) return;
      setProfile(data);
      setName(data.name);
      setBio(data.bio || '');
    }).catch(err => {
      console.error('ERROR getMyProfile:', err);
      setLoadError(true);
    });
  }, [token]);

  const handleUpdate = async () => {
    try {
      const updated = await updateMyProfile({ name, bio }, token);
      setProfile({ ...profile, ...updated });
      login(token, { ...authUser, name: updated.name });
      setEditingPersonal(false);
      setMessage('Perfil actualizado');
      setTimeout(() => setMessage(''), 3000);
    } catch { setMessage('Error actualizando perfil'); }
  };

  const handlePasswordChange = async () => {
    if (newPassword !== newPassword2) { setMessage('Las contraseñas no coinciden'); return; }
    if (newPassword.length < 6) { setMessage('Mínimo 6 caracteres'); return; }
    try {
      const res = await fetch(`${API}/users/me/password`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ currentPassword, newPassword })
      });
      const data = await res.json();
      if (!res.ok) { setMessage(data.error); return; }
      setMessage('Contraseña actualizada');
      setEditingPassword(false);
      setCurrentPassword(''); setNewPassword(''); setNewPassword2('');
      setTimeout(() => setMessage(''), 3000);
    } catch { setMessage('Error cambiando contraseña'); }
  };

  const handleAvatarChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('avatar', file);
    try {
      const response = await fetch(`${API}/users/me/avatar`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });
      const data = await response.json();
      if (!response.ok) { setMessage('Error subiendo foto'); return; }
      setProfile({ ...profile, avatar: data.avatar });
      setMessage('Foto actualizada');
      setTimeout(() => setMessage(''), 3000);
    } catch { setMessage('Error subiendo foto'); }
  };

  const handleCompartir = () => {
    const texto = '¡Descubre SenDViGo! La app donde la gente se ayuda compartiendo sus viajes 🤝 Cada viaje, una oportunidad de ayudar.';
    try {
      if (navigator.share) {
        navigator.share({ title: 'SenDViGo', text: texto });
      } else {
        navigator.clipboard.writeText(texto);
        setMessage('Texto copiado al portapapeles');
        setTimeout(() => setMessage(''), 3000);
      }
    } catch {
      navigator.clipboard?.writeText(texto);
      setMessage('Texto copiado al portapapeles');
      setTimeout(() => setMessage(''), 3000);
    }
  };

  if (showPerfil) return <PublicProfile userId={profile?.id} onBack={() => setShowPerfil(false)} />;
if (showAdmin) return <AdminPanel onBack={() => setShowAdmin(false)} />;

  if (!profile) return (
    <div className="min-h-screen pb-20" style={{backgroundColor: '#111318'}}>
      <div className="flex items-center justify-center h-64">
        {loadError ? (
  <div style={{textAlign: 'center', padding: '20px'}}>
    <p style={{color: '#f87171', fontSize: '14px', marginBottom: '16px'}}>
      Tu sesión ha expirado. Vuelve a iniciar sesión.
    </p>
    <button onClick={logout}
      style={{backgroundColor: '#f97316', color: 'white', fontWeight: '700',
        padding: '12px 24px', borderRadius: '14px', fontSize: '14px', border: 'none', cursor: 'pointer'}}>
      Cerrar sesión
    </button>
  </div>
) : (
  <p className="text-gray-500 text-sm">Cargando...</p>
)}
      </div>
      <BottomNav active="profile" onChange={onTabChange} unreadCount={0} />
    </div>
  );

  return (
    <div className="min-h-screen pb-24" style={{backgroundColor: '#111318'}}>

      {/* Cabecera */}
      <div className="px-5 pt-12 pb-6" style={{backgroundColor: '#111318'}}>
        <div className="flex items-center gap-4 mb-5">
          <div className="relative">
            {profile.avatar ? (
              <img src={profile.avatar}
                style={{width: '64px', height: '64px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #f97316'}} />
            ) : (
              <div style={{width: '64px', height: '64px', borderRadius: '50%', backgroundColor: '#1a1d24',
                border: '2px solid #f97316', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <FaUser style={{color: '#6b7280', fontSize: '24px'}} />
              </div>
            )}
            <button onClick={() => fileInputRef.current.click()}
              style={{position: 'absolute', bottom: 0, right: 0, backgroundColor: '#f97316',
                borderRadius: '50%', padding: '5px', border: '2px solid #111318'}}>
              <FaCamera style={{color: 'white', fontSize: '9px'}} />
            </button>
          </div>
          <input ref={fileInputRef} type="file" accept="image/*" onChange={handleAvatarChange} className="hidden" />
          <div className="flex-1 min-w-0">
            <p className="text-white font-semibold text-lg">{profile.name}</p>
            <p style={{color: '#6b7280', fontSize: '13px'}}>{profile.email}</p>
            {profile.bio && <p style={{color: '#9ca3af', fontSize: '12px', marginTop: '3px'}}>{profile.bio}</p>}
          </div>
        </div>

        <button onClick={() => setShowPerfil(true)}
          style={{width: '100%', border: '1px solid #f97316', color: '#f97316',
            borderRadius: '14px', padding: '10px', fontSize: '13px', fontWeight: '600', backgroundColor: 'transparent'}}
          className="transition duration-200 hover:bg-orange-500 hover:text-white">
          Ver mi perfil público
        </button>

        {message && (
          <p style={{color: message.includes('Error') ? '#f87171' : '#4ade80', fontSize: '13px'}}
            className="text-center mt-3">
            {message}
          </p>
        )}
      </div>
      
      {profile.role === 'admin' && (
  <button onClick={() => setShowAdmin(true)}
    style={{width:'100%', backgroundColor:'#f9731615', border:'1px solid #f9731640',
      color:'#f97316', borderRadius:'14px', padding:'10px', fontSize:'13px',
      fontWeight:'600', marginBottom:'10px', cursor:'pointer'}}>
    🛡️ Panel de administración
  </button>
)}

      {/* Ajustes de cuenta */}
      <div className="mt-1">
        <p style={{color: '#3a3d45', fontSize: '11px', fontWeight: '600', letterSpacing: '0.08em'}}
          className="uppercase px-5 py-2">
          Mi cuenta
        </p>

        <MenuItem emoji="👤" label="Datos personales" sublabel={profile.name}
          onClick={() => { setEditingPersonal(!editingPersonal); setEditingPassword(false); setShowLang(false); }} />
        {editingPersonal && (
          <Panel>
            <div className="flex flex-col gap-3">
              <InputField value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre" />
              <textarea value={bio} onChange={e => setBio(e.target.value)} rows={3}
                placeholder="Algo sobre ti..."
                style={{backgroundColor: '#111318', border: '1px solid #2a2d35', color: 'white',
                  borderRadius: '12px', padding: '11px 14px', fontSize: '14px', width: '100%', resize: 'none'}}
                className="focus:outline-none focus:ring-1 focus:ring-orange-500 placeholder-gray-600" />
              <div className="flex gap-2">
                <button onClick={handleUpdate}
                  style={{flex: 1, backgroundColor: '#f97316', color: 'white', fontWeight: '600', padding: '10px', borderRadius: '12px', fontSize: '13px'}}>
                  Guardar
                </button>
                <button onClick={() => setEditingPersonal(false)}
                  style={{flex: 1, backgroundColor: '#2a2d35', color: '#9ca3af', fontWeight: '600', padding: '10px', borderRadius: '12px', fontSize: '13px'}}>
                  Cancelar
                </button>
              </div>
            </div>
          </Panel>
        )}

        <MenuItem emoji="🔒" label="Cambiar contraseña"
          onClick={() => { setEditingPassword(!editingPassword); setEditingPersonal(false); setShowLang(false); }} />
        {editingPassword && (
          <Panel>
            <div className="flex flex-col gap-3">
              <InputField type="password" placeholder="Contraseña actual" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} />
              <InputField type="password" placeholder="Nueva contraseña" value={newPassword} onChange={e => setNewPassword(e.target.value)} />
              <InputField type="password" placeholder="Repetir nueva contraseña" value={newPassword2} onChange={e => setNewPassword2(e.target.value)} />
              <div className="flex gap-2">
                <button onClick={handlePasswordChange}
                  style={{flex: 1, backgroundColor: '#f97316', color: 'white', fontWeight: '600', padding: '10px', borderRadius: '12px', fontSize: '13px'}}>
                  Guardar
                </button>
                <button onClick={() => setEditingPassword(false)}
                  style={{flex: 1, backgroundColor: '#2a2d35', color: '#9ca3af', fontWeight: '600', padding: '10px', borderRadius: '12px', fontSize: '13px'}}>
                  Cancelar
                </button>
              </div>
            </div>
          </Panel>
        )}

        <MenuItem emoji="📅" label="Miembro desde" sublabel={new Date(profile.createdAt).toLocaleDateString('es-ES')} onClick={() => {}} />
        <MenuItem emoji="⭐" label="Mis agradecimientos" sublabel="Ver tu perfil público" onClick={() => setShowPerfil(true)} />
      </div>

      {/* Comunidad */}
      <div className="mt-4">
        <p style={{color: '#3a3d45', fontSize: '11px', fontWeight: '600', letterSpacing: '0.08em'}}
          className="uppercase px-5 py-2">
          Comunidad
        </p>
        <MenuItem emoji="📤" label="Invita a alguien" sublabel="Cuanto más seamos, más nos ayudamos" onClick={handleCompartir} />
        <MenuItem emoji="🌟" label="Valóranos" sublabel="Nos ayuda a seguir mejorando 😊"
          onClick={() => window.open('https://play.google.com/store/apps/details?id=com.sendvigo', '_blank')} />
        <MenuItem emoji="💡" label="¿Cómo podemos mejorar?"
          sublabel="Cuéntanos tu idea"
          onClick={() => window.open('mailto:soporte@sendvigo.app?subject=Sugerencia%20SenDViGo', '_blank')} />
      </div>

      {/* Soporte */}
      <div className="mt-4">
        <p style={{color: '#3a3d45', fontSize: '11px', fontWeight: '600', letterSpacing: '0.08em'}}
          className="uppercase px-5 py-2">
          Soporte
        </p>

        <MenuItem emoji="❓" label="Preguntas frecuentes"
          onClick={() => { setShowAyuda(!showAyuda); setShowSobre(false); }} />
        {showAyuda && (
          <Panel>
            {[
              { q: '¿Cómo publico una solicitud de ayuda?', a: 'Ve a Inicio → Pedir ayuda con un envío, rellena los datos y pulsa publicar.' },
              { q: '¿Cómo me ofrezco a llevar algo?', a: 'Ve al Panel de viajeros desde Inicio y ofrece tu ayuda en los envíos de tu ruta.' },
              { q: '¿Cómo funciona la contribución?', a: 'Quien necesita ayuda propone una aportación para compartir gastos del viaje. El acuerdo final es entre las personas.' },
              { q: '¿Puedo cancelar una solicitud?', a: 'Sí, puedes borrarla mientras esté pendiente desde Mi actividad.' },
              { q: '¿Cómo contacto con soporte?', a: 'Escríbenos a soporte@sendvigo.app y te respondemos en menos de 24h.' },
            ].map(({ q, a }) => (
              <div key={q} className="mb-4 last:mb-0">
                <p style={{color: 'white', fontSize: '13px', fontWeight: '600'}} className="mb-1">{q}</p>
                <p style={{color: '#9ca3af', fontSize: '13px'}}>{a}</p>
              </div>
            ))}
          </Panel>
        )}

        <MenuItem emoji="ℹ️" label="Sobre SenDViGo"
          onClick={() => { setShowSobre(!showSobre); setShowAyuda(false); }} />
        {showSobre && (
          <Panel>
            <div className="text-center mb-4">
              <p className="text-white font-bold text-lg">Sen<span style={{color: '#f97316'}}>DV</span>iGo</p>
              <p style={{color: '#f97316', fontSize: '11px', fontStyle: 'italic'}} className="mt-1">
                Cada viaje, una oportunidad de ayudar
              </p>
              <p style={{color: '#6b7280', fontSize: '11px'}} className="mt-0.5">Versión 1.0.0</p>
            </div>
            <p style={{color: '#9ca3af', fontSize: '13px', lineHeight: '1.6'}} className="mb-3">
              SenDViGo es una comunidad de personas que se ayudan mutuamente. Si alguien viaja, puede llevar algo de paso. Si alguien necesita enviar algo, puede encontrar a alguien que ya va hacia allí.
            </p>
            <p style={{color: '#9ca3af', fontSize: '13px', lineHeight: '1.6'}} className="mb-4">
              No somos una empresa de transportes. Somos personas que comparten el camino.
            </p>
            <div style={{borderTop: '1px solid #2a2d35', paddingTop: '14px'}}>
              <p style={{color: '#3a3d45', fontSize: '11px'}} className="text-center">© 2026 SenDViGo · Todos los derechos reservados</p>
              <p style={{color: '#3a3d45', fontSize: '11px'}} className="text-center mt-1">soporte@sendvigo.app</p>
            </div>
          </Panel>
        )}
      </div>
<MenuItem emoji="🗑️" label="Eliminar cuenta" sublabel="Esta acción no se puede deshacer" danger
  onClick={async () => {
    const confirmar = window.confirm('¿Seguro que quieres eliminar tu cuenta? Esta acción es irreversible.');
    if (!confirmar) return;
    try {
      await fetch(`https://sendvigo-backend-production.up.railway.app/users/me`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      logout();
    } catch {
      setMessage('Error eliminando cuenta');
    }
  }} />
  <MenuItem emoji="📄" label="Política de privacidad" onClick={() => setShowPrivacidad(!showPrivacidad)} />
{showPrivacidad && <LegalPanel title="Política de Privacidad" sections={PRIVACIDAD} />}

<MenuItem emoji="📋" label="Términos y condiciones" onClick={() => setShowTerminos(!showTerminos)} />
{showTerminos && <LegalPanel title="Términos y Condiciones" sections={TERMINOS} />}

      <div className="mt-4 mb-2">
        <MenuItem emoji="🚪" label="Cerrar sesión" danger onClick={logout} />
      </div>

      <p style={{color: '#3a3d45', fontSize: '11px'}} className="text-center mb-6">SenDViGo v1.0.0</p>

      <BottomNav active="profile" onChange={onTabChange} unreadCount={0} />
    </div>
  );
}